module.exports = __webpack_public_path__ + "media/images/flags/64/Saint-Martin-ecd62b8557fd34283aa9b3adc73d349f.png";